import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { roleOptions } from 'src/api/types';
import { Role } from 'src/graphql/_generated';
import { OptionWithHint } from 'src/components/form/Select/comps';

interface RoleSelectProps extends Omit<Props, 'value' | 'options'> {
  value: Role | undefined | null;
  onChange: (value: { label: string; value: Role }, meta: ActionMeta<{ label: string; value: Role }>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  filteredOutRoles?: Role[];
  disabledOptions?: { value: Role; reason: string }[];
  optionTooltips?: { value: Role; reason: string }[];
}

interface OptionType {
  label: string;
  value: Role;
  isDisabled?: boolean;
  hint?: string;
}

export const RoleSelect: React.FC<RoleSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select role',
  filteredOutRoles,
  disabledOptions,
  optionTooltips,
  ...rest
}) => {
  const baseOptions = filteredOutRoles?.length
    ? roleOptions.filter((option) => !filteredOutRoles.includes(option.value))
    : roleOptions;

  const options: OptionType[] = _.orderBy(
    baseOptions.map((option) => {
      const disabledOption = disabledOptions?.find((d) => d.value === option.value);
      const tooltipOption = optionTooltips?.find((t) => t.value === option.value);
      return {
        ...option,
        isDisabled: !!disabledOption,
        hint: disabledOption?.reason || tooltipOption?.reason,
      };
    }),
    [(option) => option.isDisabled, (option) => option.label.toLowerCase()],
    ['asc', 'asc'],
  );

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(options, (o) => o.value === value)}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        onBlur={onBlur}
        inputId="role-select"
        name="role"
        components={{ Option: OptionWithHint }}
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
